import { useSelector } from "react-redux";
import { StateExtended } from "../../_config/interfaces/stateExtended";

export const useRolesSelector = () => useSelector((state: StateExtended) => state.userManagement.roleList);
